module.exports = __webpack_public_path__ + "media/components/outside-promo-page/static/app-card-mountain-96bb9fd9abb28f265a2f5031c9be18f7.webp";